import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navigation"
export default class extends Controller {
  static targets = ['toggle']
  
  connect() {
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }
  
  toggle(e) {
    e.preventDefault();

    const link = e.target.closest('a');
    const item = link.dataset.toggle;

    if (link.classList.contains('active')) {
      this.resetAll()
    }
    else {
      this.resetAll()
      link.classList.add('active')
      this.element.querySelector(`#${item}`).classList.add('active')
    }
  }

  resetAll() {
    this.element.querySelectorAll('.active').forEach((el) => el.classList.remove('active'))
  }

  handleClickOutside(e) {
    if (!this.element.contains(e.target)) {
      this.resetAll()
    }
  }
}